import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b99d55c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { withDefaults, useSlots, computed } from 'vue'

interface Props {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span',
  text? : String
}


import { defineComponent } from 'vue'

const __default__ = defineComponent({})

function setup(__props: any) {

const props = __props as { tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span', text? : String }



const slots = useSlots()
const text = computed(() => {
  if (props.text) return props.text
  return slots.default ? slots.default()[0].children : ''
})
const textAttr = computed(() => text.value ? (text.value as String).replaceAll('<br>', '\n') : '')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    class: "Heading",
    "data-text": _unref(textAttr)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        ref: (_value, _refs) => {
          _refs['inner'] = _value
        },
        class: "Inner"
      }, [
        (props.text)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: _unref(text)
            }, null, 8, _hoisted_1))
          : _renderSlot(_ctx.$slots, "default", { key: 1 })
      ], 512)
    ]),
    _: 3
  }, 8, ["data-text"]))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tag: { default: 'div' },
    text: null
  },
  setup})